import "./FormStyles.css";

import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Form = () => {
  const form = useRef();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const validateForm = (e) => {
    let userName = document.getElementById("userName");
    let userEmail = document.getElementById("userEmail");
    let userSubject = document.getElementById("userSubject");

    let flag = true;

    if (userName.value === "" || userName.value.length < 3) {
      document.getElementById("userNameError").innerHTML =
        "Name is required and must be at least 3 characters long";
      flag = false;
    } else {
      document.getElementById("userNameError").innerHTML = "";
    }

    if (userEmail.value === "") {
      document.getElementById("userEmailError").innerHTML =
        "Email is required";
      flag = false;
    } else {
      document.getElementById("userEmailError").innerHTML = "";
    }

    if (userSubject.value === "") {
      document.getElementById("userSubjectError").innerHTML =
        "Subject is required";
      flag = false;
    } else {
      document.getElementById("userSubjectError").innerHTML = "";
    }

    return flag;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (validateForm()) {
      emailjs
        .sendForm("service_rthgnni", "template_b0yxgc7", form.current, {
          publicKey: "cwugFD2rnEFJlgQ-A",
        })
        .then(() => {
          console.log("SUCCESS!");
          setShowSuccessMessage(true);
          setTimeout(()=>{
            form.current.reset();
            setShowSuccessMessage(false);
          },3000);
        })
        .catch((error) => {
          console.error("FAILED...", error.text);
        });
    }
  };

  return (
    <div className="form">
      <form ref={form} onSubmit={sendEmail}>
        <label>Your Name: </label>
        <input id="userName" type="text" name="person_name" />
        <p id="userNameError" className="error"></p>

        <label>From Enter Your Email: </label>
        <input id="userEmail" type="email" name="from_name" />
        <p id="userEmailError" className="error"></p>

        <label>To:</label>
        <input
          type="email"
          value="ayansrivastava322@gmail.com"
          className="to"
        />

        <label>subject:</label>
        <input id="userSubject" type="text" name="to_name" />
        <p id="userSubjectError" className="error"></p>

        <label>Message:</label>
        <textarea
          rows="6"
          placeholder="Type Your Message Here"
          name="message"
        />

        <button className="btn" type="submit">
          Submit
        </button>
      </form>

      {showSuccessMessage && (
        <div className="success-popup">
          <p>Mail has been sent successfully!</p>
        </div>
      )}
    </div>
  );
};

export default Form;
